const isSearchPage = !!new URLSearchParams(window.location.search).get("q");
const isCollectionPage = !isSearchPage;

// AIMS 29/09/26: % off badge, only on the "event-list-percentage-dis" collection template.
// Single-variant cards show "X% OFF" (rounded down so the saving is never overstated).
// Multi-variant cards show "SALE", since variants can carry different discounts.
function aimsDiscountBadge(hit) {
  if (!document.body.classList.contains("event-list-percentage-dis")) return null;
  if (hit._distinct && Number(hit.variants_count) > 1) {
    return Number(hit.variants_compare_at_price_max) > Number(hit.variants_min_price) ? "Sale" : null;
  }
  const price = Number(hit.price);
  const compare = Number(hit.compare_at_price);
  if (!(price > 0 && compare > price)) return null;
  const pct = Math.floor((1 - price / compare) * 100);
  return pct >= 1 ? `${pct}% OFF` : null;
}

function fixFloatGaps() {
  const list = document.querySelector('.ais-Hits-list');
  if (!list) return;

  const items = [...list.querySelectorAll('.ais-Hits-item')];
  let currentRowTop = null;
  let maxRowHeight = 0;
  let currentRowItems = [];

  function applyRowHeight(rowItems, height) {
    rowItems.forEach(el => el.style.height = height + 'px');
  }

  items.forEach((item) => {
    const rect = item.getBoundingClientRect();
    if (currentRowTop === null || Math.abs(rect.top - currentRowTop) > 10) {
      if (currentRowItems.length) applyRowHeight(currentRowItems, maxRowHeight);
      currentRowTop = rect.top;
      maxRowHeight = rect.height;
      currentRowItems = [item];
    } else {
      maxRowHeight = Math.max(maxRowHeight, rect.height);
      currentRowItems.push(item);
    }
  });
  if (currentRowItems.length) applyRowHeight(currentRowItems, maxRowHeight);
}

document.addEventListener("algolia.hooks.initialize", () => {
  document.getElementById('algolia-shopify-instantsearch')
  ?.classList.add('algolia-loaded');

  const staticHtmlIns = [
    {symbol:'<svg width="15" height="15" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 16.875L15 3.125C15 2.43464 14.4404 1.875 13.75 1.875L6.25 1.875C5.55964 1.875 5 2.43464 5 3.125L5 16.875C5 17.5654 5.55964 18.125 6.25 18.125H13.75C14.4404 18.125 15 17.5654 15 16.875Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 5.625C10.5178 5.625 10.9375 5.20527 10.9375 4.6875C10.9375 4.16973 10.5178 3.75 10 3.75C9.48223 3.75 9.0625 4.16973 9.0625 4.6875C9.0625 5.20527 9.48223 5.625 10 5.625Z" fill="currentColor"></path></svg>',
      label: "Talk to an expert", url: "tel:+61297730122"},
    {symbol:'', label: "Contact Support", url: "/pages/contact-us"},
    {symbol:'', label: "Browse Technical Guides", url: "/blogs/learning-hub"},
    {symbol:'', label: "View Articles", url: "/pages/faq"}
  ];

  const staticKeywordsIns = [
    { label: "Bush", url: "/search?q=bush" },
    { label: "m10x", url: "/search?q=m10+x" },
    { label: "Vent", url: "/search?q=vent" },
    { label: "Loctite", url: "/search?q=loctite" },
    { label: "Sutton", url: "/search?q=sutton" },
    { label: "Fuel", url: "/search?q=fuel" },
    { label: "CRC", url: "/search?q=crc" }
  ];

  const categoriesIns = [
    { label: "Clearance Sale", url: "/collections/clearance-sale" },
    { label: "New Arrivals", url: "/collections/new-arrivals" },
    { label: "On Sale", url: "/collections/on-sale" },
    { label: "Promotions", url: "/pages/promotions" },
    { label: "Shop By Category", url: "/collections/shop-by-category" }
  ];

  const brandsIns = [
    { label: "Alemlube", url: "/collections/alemlube" },
    { label: "Champion", url: "/collections/champion" },
    { label: "Galmet", url: "/collections/galmet" },
    { label: "Gates", url: "/collections/gates" },
    { label: "Macnaught", url: "/collections/macnaught" },
    { label: "Nachi", url: "/collections/nachi" },
    { label: "Stahlwille", url: "/collections/stahlwille" },
    { label: "Sutton Tools", url: "/collections/sutton-tools" },
    { label: "View All Brands", url: "/collections/shop-by-brand" }
  ];

  const HIDDEN_FACET_VALUES = {
    "vendor": ["Bremick", "Hobson"],
    "ANOTHER_ATTRIBUTE": ["VALUE_TO_HIDE_3"]
  };

  const query = algoliaShopify.instantsearch?.search?.helper?.state?.query || new URLSearchParams(window.location.search).get("q");

  function getCurrentPage() {
    let page = 0;
    if (
      typeof algoliaShopify !== 'undefined' &&
      algoliaShopify.instantsearch &&
      algoliaShopify.instantsearch.helper
    ) {
      page = algoliaShopify.instantsearch.helper.getPage();
    } else {
      const urlPage = Number(new URLSearchParams(window.location.search).get("page"));
      if (!isNaN(urlPage) && urlPage > 0) page = urlPage - 1;
    }
    return page;
  }

  function insertCollectionBanner() {
    // To hide banner, add early return;
    
return;
    if (!isCollectionPage) { return; }
    const container = document.querySelector(".ais-hits-container");
    if (!container) { return; }
    if (container.querySelector(".ais-promo-card")) { return; }
    const firstHit = container.querySelector(".ais-Hits-item");
    if (!firstHit) { return; }
    const banner = createBanner({
      image: "https://cdn.shopify.com/s/files/1/0740/5191/1957/files/AIMS_EOFY_Banner_Collections.jpg?v=1778053875",
      url: "https://aimsindustrial.com.au/collections/on-sale"
    });
    firstHit.parentNode.insertBefore(banner, firstHit);
  }

  let bannersInjected = false;

  function createBanner({ image, url }) {
    const bannerItem = document.createElement("li");
    bannerItem.className = "ais-Hits-item";
    const bannerDivItem = document.createElement("div");
    bannerDivItem.className = "ais-hit ais-product";
    const banner = document.createElement("a");
    banner.href = url;
    banner.target = "_blank";
    banner.className = "ais-promo-card";
    banner.style.display = "block";
    banner.style.marginBottom = "24px";
    banner.innerHTML = `<img class="ais-hit--picture" src="${image}" alt="Promo" style="width:70%;height:auto;border-radius:8px;box-shadow:0 2px 8px #0002;">`;
    banner.addEventListener('click', function(event) {
      event.stopPropagation();
    });
    bannerDivItem.append(banner);
    bannerItem.append(bannerDivItem);
    return bannerItem;
  }


  function cleanupBanners() {
    document.querySelectorAll('.ais-promo-card').forEach(el => el.remove());
  }

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchAsyncFunction",
    async () => {
      document.body.classList.remove('algolia-no-results');
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchMainTemplate",
    (_defaultTemplate, data, html) => {

      setTimeout(() => {
  cleanupBanners();      
  insertCollectionBanner();
  fixFloatGaps();
}, 700);

      return html`
        <div class="ais-page ais-custom-aiims">
          ${!!new URLSearchParams(window.location.search).get("q")
            ? html`<h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>`
            : ""}
          <div style="visibility:hidden" class="ais-input">
            <div style="display:none;" class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>
          <div class="ais-facets-button">
            ${algoliaShopify.translations.showFilters}
          </div>
          <div class="ais-facets">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${
              algoliaShopify.config.app_blocks_dynamic_widgets_beta_enabled
                ? html`<div class="ais-dynamic-widgets-container"></div>`
                : data.facets.map(facet => html`
                    <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                      <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">${facet.title}</label>
                      <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
                      <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                    </div>
                  `)
            }
          </div>
          <div class="ais-block">
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                <span class="ais-change-display-block ais-change-display-selected">
                  <i class="fa fa-th-large"></i>
                </span>
                <span class="ais-change-display-list">
                  <i class="fa fa-th-list"></i>
                </span>
              </div>
              <div class="ais-sort">
                ${data.multipleSortOrders
                  ? html`${algoliaShopify.translations.sortBy}<span class="ais-sort-orders-container"></span>`
                  : html`${algoliaShopify.translations.sortBy}${algoliaShopify.translations.relevance}`
                }
              </div>
            </div>
            <div class="ais-hits-container ais-results-as-block"></div>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
      `;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFacetParamsOptions",
    (facetParams, facet) => {
      if (facet.type === "disjunctive" || facet.type === "conjustive") {
        facetParams.sortBy = (a, b) => {
          return a.name.localeCompare(b.name, undefined, {
            numeric: true,
            sensitivity: "base",
          });
        };
      }
      return facetParams;
    }
  );

  // ── beforeInstantSearchFacetPanelOptions ────────────────────────────────
  // FIX (17/09/26): facet names containing brackets crashed the product grid.
  //
  // The Algolia app builds a CSS class selector from the facet attribute name
  // to show/hide empty facet panels, escaping only "." and "%":
  //
  //   `.ais-facet-${encodeURIComponent(facet.name)
  //        .replace(/\./g, "\\.").replace(/\%/g, "\\%")}`
  //
  // encodeURIComponent() does not encode "(" or ")", so a facet such as
  // options.diameter_(inch) produced `.ais-facet-options\.diameter_(inch)`,
  // which is not a valid CSS selector. document.querySelector() threw a
  // SyntaxError, the render aborted, and the collection page showed filters
  // with zero products. Affected Threading, Milling and Surface Finishing.
  //
  // This replaces the panel's `hidden` callback with an equivalent that uses
  // an attribute selector. Quoted attribute values need no escaping, so any
  // character in the facet name is safe. It is the same approach the app
  // already uses for the facet container lookup. The try/catch is deliberate:
  // panel visibility must never be able to abort hit rendering again.
  //
  // Safe to remove if Algolia ships a fix that uses CSS.escape.
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFacetPanelOptions",
    (panelOptions, facet) => ({
      ...panelOptions,
      hidden(options) {
        const isHidden = !options.canRefine;
        try {
          const name = encodeURIComponent(facet.name);
          const panel = document.querySelector(`[class~="ais-facet-${name}"]`);
          if (panel) panel.style.display = isHidden ? "none" : "";
        } catch (e) {
          /* never let panel visibility abort the hit rendering */
        }
        return isHidden;
      },
    })
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchNoResultTemplate",
    (_defaultTemplate, html) => {
      document.body.classList.add('algolia-no-results');
      return html`...`;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchAllowParamsArray",
    function () {
      const allowParamsArray = [...arguments, "price"];
      return allowParamsArray;
    },
  );

  // ── Single beforeInstantSearchConfigurationOptions hook ──────────────────
  // Handles: stalled search delay + query normalisation (e.g. "10x20" → "10 x 20")
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchConfigurationOptions",
    (options) => {
      //options.stalledSearchDelay = 100;

      const q = options.query || "";
      const normalized = q.replace(/(\d+)x(\d+)/gi, "$1 x $2");
      if (normalized !== q) {
        options.query = normalized;
      }

      return options;
    }
  );

  // ── beforeInstantSearchOptions ───────────────────────────────────────────
  // Collection pages: distinct:true  → one card per product handle (no duplicates)
  // Search results:   distinct:false → every variant/SKU shown individually
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchOptions",
    function (options) {

      options.distinct = isCollectionPage ? true : false;

      const widgets = options.facets.widgets.map((widget) => {
        if (widget.name !== "refinementList") { return widget; }

        const attr = widget.params.attribute;
        if (!HIDDEN_FACET_VALUES[attr] || !Array.isArray(HIDDEN_FACET_VALUES[attr])) return widget;

        return {
          ...widget,
          params: {
            ...widget.params,
            transformItems: items =>
              items.filter(item =>
                !HIDDEN_FACET_VALUES[attr].includes(item.label)
              )
          }
        };
      });

      return {
        ...options,
        facets: {
          ...options.facets,
          widgets,
        },
      };
    },
  );

  // ── Product card template ────────────────────────────────────────────────
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    (_defaultTemplate, hit, html, components) => {

      // Skip ghost/empty records that can appear as blank grid slots
      if (!hit.title || !hit.objectID) return html``;

      const pctBadge = aimsDiscountBadge(hit);

      return html`
        <div
          class="ais-hit ais-product"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
          onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
        >
          ${pctBadge && html`<span class="aims-pct-badge">${pctBadge}</span>`}
          <img
            class="ais-hit--picture motion-reduce loaded"
            src="${algoliaShopify.helpers.mediumImage(hit)}"
            alt="${hit.title} - ${hit.variant_title}"
            sizes="(max-width: 767px) calc((100vw - 38px) / 2), (max-width: 1279px) calc((100vw - 90px) / 3),calc(1700px / 6)"
          />
          <div class="ais-hit--details">
            <p class="ais-hit--title">
              <a
                data-algolia-index="${hit.index}"
                data-algolia-position="${hit.productPosition}"
                data-algolia-queryid="${hit.queryID}"
                data-algolia-objectid="${hit.objectID}"
                href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                title="${algoliaShopify.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}"
              >
                ${components.Highlight({ attribute: "title", hit })}
                ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
              </a>
            </p>
            <p class="ais-hit--subtitle" title="${hit.product_type}${algoliaShopify.translation_helpers.by(hit.vendor)}">
              ${components.Highlight({ attribute: "product_type", hit })}
              ${hit.vendor && html`<span> ${algoliaShopify.translations.by} </span>`}
              ${hit.vendor && components.Highlight({ attribute: "vendor", hit })}
            </p>

            <p class="ais-hit--price">
              <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
              ${!hit._distinct && html`
                <span class="ais-hit--price-striked">
                  <span>${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}</span>
                </span>
              `}
              ${!hit._distinct && html`
                <span class="ais-hit--price-discount">
                  ${algoliaShopify.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)}
                </span>
              `}
            </p>

            <!-- Tags — remove display:none to show -->
            <p class="ais-hit--tags" style="display: none">
              ${hit?._highlightResult.tags?.map(
                (tag) => html`<span class="ais-hit--tag">${tag.value}</span>`
              )}
            </p>

            ${hit._distinct && hit.variants_count > 1
              ? html`
                  <p class="ais-hit--cart">
                    <a
                      class="ais-hit--cart-button ais-hit--select-options"
                      href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                    >
                      Select Options
                    </a>
                  </p>
                `
              : html`
                  <form
                    id="algolia-add-to-cart-${hit.objectID}"
                    style="display: none;"
                    action="/cart/add"
                    method="post"
                    enctype="multipart/form-data"
                  >
                    <input type="hidden" name="id" value="${hit.objectID}" />
                  </form>
                  <p class="ais-hit--cart">
                    ${hit.can_order
                      ? html`
                          <button
                            class="ais-hit--cart-button"
                            data-form-id="algolia-add-to-cart-${hit.objectID}"
                          >
                            ${algoliaShopify.translations.addToCart}
                          </button>
                        `
                      : html`
                          <button class="ais-hit--cart-button ais-hit--cart-button__disabled">
                            ${algoliaShopify.translations.outOfStock}
                          </button>
                        `
                    }
                  </p>
                `
            }
          </div>
        </div>
      `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchNoResultTemplate",
    (_defaultTemplate, html) => html`
      <div class="aa-PanelLayout aa-Panel ais-CustomNoResultWrapper">
        <div class="ais-noResultLabel"><strong>No results found.</strong></div>
        <div class="aa-PanelSections">
          <div class="aa-PanelSection aa-PanelSection--left">
            <div class="aa-NoResultsBlock">
              <div class="aa-SourceHeader">
                <span class="aa-SourceHeaderTitle">Explore Categories:</span>
                <div class="aa-SourceHeaderLine"></div>
              </div>
              <ul class="aa-List">
                ${staticKeywordsIns.map(item => html`
                  <li class="aa-Item">
                    <a href="${item.url}" title="${item.label}" class="aa-NoResultsLink">${item.label}</a>
                  </li>
                `)}
              </ul>
            </div>
            <div class="aa-NoResultsBlock">
              <div class="aa-SourceHeader">
                <span class="aa-SourceHeaderTitle">Reach out to us:</span>
                <div class="aa-SourceHeaderLine"></div>
              </div>
              <ul class="aa-List">
                ${staticHtmlIns.map(item => html`
                  <li class="aa-Item">
                    <a href="${item.url}" title="${item.label}" class="aa-NoResultsLink">
                      ${item.symbol ? html([item.symbol]) : ""}
                      <span>${item.label}</span>
                    </a>
                  </li>
                `)}
              </ul>
            </div>
          </div>
          <div class="aa-PanelSection aa-PanelSection--right">
            <div class="aa-SourceHeader">
              <span class="aa-SourceHeaderTitle">Popular Brands:</span>
              <div class="aa-SourceHeaderLine"></div>
            </div>
            <ul class="aa-List">
              ${brandsIns.map(item => html`
                <li class="aa-Item">
                  <a href="${item.url}" title="${item.label}" class="aa-NoResultsLink">
                    ${item.label}
                  </a>
                </li>
              `)}
            </ul>
          </div>
        </div>
      </div>
    `,
  );

});